import React from 'react';
import { Header } from './components/Header';
import { HeroSection } from './components/HeroSection';
import { TrustBar } from './components/TrustBar';
import { PainPoints } from './components/PainPoints';
import { Features } from './components/Features';
import { Chapters } from './components/Chapters';
import { Testimonial } from './components/Testimonial';
import { Pricing } from './components/Pricing';
import { FAQ } from './components/FAQ';
import { Footer } from './components/Footer';
export function App() {
  return <div className="min-h-screen bg-[#0A192F] text-[#FFF8F0] selection:bg-[#D4AF37]/30 selection:text-[#FFF8F0]" data-id="element-0">
      <Header data-id="element-1" />
      <main data-id="element-2">
        <HeroSection data-id="element-3" />
        <TrustBar data-id="element-4" />
        <PainPoints data-id="element-5" />
        <Features data-id="element-6" />
        <Chapters data-id="element-7" />
        <Testimonial data-id="element-8" />
        <Pricing data-id="element-9" />
        <FAQ data-id="element-10" />
      </main>
      <Footer data-id="element-11" />
    </div>;
}